import React from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import styles from "../../../styles/styles";
import SearchIcon from "@mui/icons-material/Search";
import DataTable from "../../DataTable";
import { Navigate, useNavigate } from "react-router-dom";

const FormModules = () => {
  const navigate = useNavigate();
  const columns = [
    {
      field: "moduleName",
      headerName: "Module Name",
      flex: 1,
    },
    { field: "form_name", headerName: "Form Name", flex: 1 },
    { field: "updatedAt", headerName: "Updated At", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "flex" }}>
          <IconButton
            size="small"
            onClick={() => navigate("/dashboard/matter-template")}
          ></IconButton>
        </Box>
      ),
    },
  ];
  const rows = [
    {
      id: 1,
      moduleName: "Task ",
      form_name: "New Task",
      updatedAt: "2022-01-01",
    },
    {
      id: 2,
      moduleName: "Matters",
      form_name: "Add New Matter",
      updatedAt: "2022-01-02",
    },
    {
      id: 3,
      moduleName: "Contacts",
      form_name: "Add New Contact",
      updatedAt: "2022-01-02",
    },
    {
      id: 4,
      moduleName: "Activities",
      form_name: "Add Time & Expense Entry",
      updatedAt: "2022-01-02",
    },
    {
      id: 5,
      moduleName: "Billing",
      form_name: "New Task",
      updatedAt: "2022-01-02",
    },
    {
      id: 6,
      moduleName: "Accounts",
      form_name: "Create New Account",
      updatedAt: "2022-01-02",
    },
  ];
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" className={styles.title}>
          Form Modules
        </Typography>
        <Box>
          <TextField
            fullWidth
            placeholder="Search modules..."
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{
              borderRadius: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />
        </Box>
      </Box>

      <Box>
        <DataTable
          columns={columns}
          rows={rows}
          // CustomNoRowsOverlay={CustomNoRowsOverlay}
          // loading={loading}
        />
      </Box>
    </Box>
  );
};

export default FormModules;
